import React from 'react';
import Waypoint from 'react-waypoint';
import spirit from 'spiritjs';

const Star = () => (
  <span>
    <Waypoint
      onEnter={() => spirit.loadAnimation({
          loop: false,
          path: './animation/star.json'
        })}
    />
    <svg id="star"
      data-spirit-id="star"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Main" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="artbord" transform="translate(-539.000000, -1261.000000)">
          <polygon fill="#FFFFFF" transform="translate(550.500000, 1273.500000) rotate(-348.000000) translate(-550.500000, -1273.500000)" points="550.5 1279.75 543.152684 1283.61271 544.555897 1275.43136 538.611794 1269.63729 546.826342 1268.44364 550.5 1261 554.173658 1268.44364 562.388206 1269.63729 556.444103 1275.43136 557.847316 1283.61271"></polygon>
        </g>
      </g>
    </svg>
  </span>
)

export default Star



// WEBPACK FOOTER //
// ./src/components/Star.js